<script>

    import dayjs from "dayjs";
    import Easepick from '../lib/easepick-svelte/Easepick.svelte'
    import {createEventDispatcher, onMount} from "svelte";
    import {Dropdown} from "carbon-components-svelte";

    const dispatch = createEventDispatcher();

    export let selected = "all";
    let dateRange = {
        'start': false,
        'end': parseInt(new Date().getTime() / 1000),
        'selected': selected,
        'year': ""
    };

    export let showSearch = false;
    export let startDate;
    export let allowDropdown = true;
    export let keyword;


    let calendarContainer;
    let calendarLitepicker;

    let easepickIsShown;

    let selectedYear = 2023

    let triggerCalendar = () => {

        selected = 'lightpicker';

        calendarLitepicker.open();
        easepickIsShown = true;

    };


    let closeCalendar = () => {

        if (easepickIsShown) {
            calendarLitepicker.close();
            easepickIsShown = false;
        }

    };

    let calendarDatesSelected = (evt) => {

        dateRange['start'] = parseInt(new Date(evt.detail['startDate']).getTime() / 1000);
        dateRange['end'] = parseInt(new Date(evt.detail['endDate']).getTime() / 1000);
        dateRange['selected'] = "custom"

        eventDispatcher();

    };

    let listOptionSelected = (value) => {

        selected = value;

        dateRange['selected'] = value;

        switch (value) {

            case '2023':
                // Set the start date to the beginning of the year 2023
                dateRange['start'] = parseInt(new Date('2023-01-01T00:00:00').getTime() / 1000);
                // Set the end date to the end of the year 2023
                dateRange['end'] = parseInt(new Date('2023-12-31T23:59:59').getTime() / 1000);

                dateRange['year'] = value
                dateRange['selected'] = "yearly"
                break;

            case '2022':
                // Set the start date to the beginning of the year 2023
                dateRange['start'] = parseInt(new Date('2022-01-01T00:00:00').getTime() / 1000);
                // Set the end date to the end of the year 2023
                dateRange['end'] = parseInt(new Date('2022-12-31T23:59:59').getTime() / 1000);

                dateRange['year'] = value
                dateRange['selected'] = "yearly"
                break;

            case '2024':
                // Set the start date to the beginning of the year 2023
                dateRange['start'] = parseInt(new Date('2023-01-01T00:00:00').getTime() / 1000);
                // Set the end date to the end of the year 2023
                dateRange['end'] = parseInt(new Date('2023-12-31T23:59:59').getTime() / 1000);

                dateRange['year'] = value
                dateRange['selected'] = "yearly"
                break;

            default:

                dateRange['start'] = startDate;
        }

        eventDispatcher();

    };

    let eventDispatcher = () => {

        dispatch('dates', dateRange);
    };



</script>


<!--<svelte:window on:click|stopPropagation={closeCalendar}/>-->


<header>

    <div id="date-selection">

        <div id="date-selector">

            <ul>

                <li class:active={selected === 'all'} on:click={() => listOptionSelected('all')} data-range="all">Alle</li>
                <li class:active={selected === 'yearly'} class="yearly" data-range="yearly">
                    Jährlich
                    <div class="yearly-dropdown">
                        <div on:click={() => listOptionSelected('2024')}>2024</div>
                        <div on:click={() => listOptionSelected('2023')}>2023</div>
                        <div on:click={() => listOptionSelected('2022')}>2022</div>
                    </div>
                </li>

                <li
                        id="datepicker"
                        class:active={selected === 'lightpicker'}
                        on:click|self={() => triggerCalendar()}>

                    <img
                            src="images/icons/icon-calendar.svg"
                            on:click|self={() => triggerCalendar()} />

                    <div
                            id="calendar-container"
                            bind:this={calendarContainer}
                            style="display: none;">

                        <Easepick
                                bind:this={calendarLitepicker}
                                bind:element={calendarContainer}
                                on:selected={calendarDatesSelected}
                                calendars={2}
                                firstDay={1}
                                autoApply={false}
                                css={['/css/easepick.css']}
                        />

                    </div>

                </li>

            </ul>
        </div>
    </div>

    <!--{#if showSearch}-->

    <!--    <Search-->
    <!--        keyword={keyword}-->
    <!--        on:searchevent-->
    <!--        allowDropdown={allowDropdown}-->
    <!--    />-->

    <!--{/if}-->


</header>

<style>

    header {
        /*position: absolute;*/
        display: flex;
        justify-content: center;
        /*width: calc(100vw - 9.26vh - 8.23vh);*/
        left: 9.26vh;
        padding: 3.7vh 4.53vh;
        z-index: 999;
    }

    #date-selection {
        /*position: absolute;*/
        display: flex;
        flex-direction: column;
        top: 2.08vw;
        left: 50%;
        transform: translate(-50%, 0);
    }

    #date-selection #date-selector {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    #date-selection ul {
        display: flex;
        flex-direction: row;
        padding: 0.28vh 0.18vh;
        margin: 0;
        list-style-type: none;
        background-color: #FFFFFF;
        border-radius: 2.84vh;
    }

    #date-selection ul li,
    #date-selection #datepicker {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 7.41vh;
        height: 3.7vh;
    }

    #date-selection ul li {
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        font-size: 1.78vh;
        color: #000000;
        border-radius: inherit;
        user-select: none;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    #date-selection ul li.active,
    #date-selection ul li:hover {
        color: white;
        background-color: #3247E5;
    }

    #date-selector #datepicker img {
        height: 3vh;
        transition: all 0.3s ease;
    }

    #date-selector #datepicker.active img,
    #date-selector #datepicker:hover img {
        filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(201deg) brightness(106%) contrast(106%);
    }

    :global(#datepicker .easepick-wrapper) {
        position: absolute;
        color: inherit;
        max-width: none;
        /*z-index: 3001;*/
        top: 6vh;
        left: 50%;
        right: auto;
        display: flex;
        /*background-color: white;*/
        transform: translate(-50%, 0);
        font-family: 'Roboto', sans-serif;
        border: 0;
        border-radius: 1.39vh;
        z-index: 100;
    }

    .yearly {
        position: relative;
    }

    .yearly:hover > .yearly-dropdown {
        display: flex;

    }

    .yearly-dropdown {
        display: none;
        height: auto;
        position: absolute;
        top: 100%;
        left: 0;
        flex-direction: column;
        color: black;
        background-color: white;
        width: 100%;
        text-align: center;
    }

    .yearly-dropdown div:hover {
        background-color: #3247E5;
        color: white;
    }

    .yearly-dropdown div {
        padding: 1vh;
        border-radius: 1.39vh;
    }

</style>
